import { Box, Container, Flex, Image, Text } from '@chakra-ui/react';
import RegistrationForm from '../components/Form';

// Caminho para a logo - estático
const logoPath = "/assets/logos/LOGO_ITALIA.png";

const RegistrationPage = () => {
  return (
    <Box bg="gray.50" minH="100vh">
      <Container maxW="container.md" py={8}>
        <Flex direction="column" align="center" justify="center" minH="80vh">
          <RegistrationForm />
          
          <Flex mt={8} direction={{ base: 'column', md: 'row' }} align="center" justify="center" gap={4}>
            <Image src={logoPath} alt="Logo Consulado" maxH="60px" />
            <Text fontSize="sm" color="gray.600" textAlign="center">
              © {new Date().getFullYear()} - Consulado Geral da Itália em Porto Alegre
            </Text>
          </Flex>
        </Flex>
      </Container>
    </Box>
  );
};

export default RegistrationPage; 